import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  ScrollArea,
} from "web-design-system";
import { ChevronDownIcon } from "lucide-react";
import { EditColumns, EditFieldsProps } from "./edit-fields";

export function EditFieldsPopover(props: EditFieldsProps) {
  const { className, ...rest } = props;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className={className}>
          Edit columns
          <ChevronDownIcon className="size-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="!max-w-none w-auto h-[50vh] p-0 max-h-[70vh]"
      >
        <ScrollArea className="w-60 p-4 h-full">
          <EditColumns {...rest} />
        </ScrollArea>
      </PopoverContent>
    </Popover>
  );
}
